import { useContext } from "react";
import { GlobalsContext } from "../../../../components/Context/globalsContext";

var daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday", 
    "Saturday"
];
const formatDate = (dateObj)=>{
    var date = new Date(dateObj);
    return daysOfWeek[date.getDay()] +', '+date.toLocaleString();
}

export default function LargeFirmEvent() {

    const { state: globalsContext } = useContext(GlobalsContext);
    const renderHtml = (htmlTag)=>{
        return {__html: htmlTag};
    }
    const renderDateHtml = (htmlTag)=>{
        htmlTag = formatDate(htmlTag);
        return {__html: htmlTag};
    }
    return (
        <>
      <div className ="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div className="px-4">
                            <div className="px-4">
                                <div dangerouslySetInnerHTML={renderHtml(globalsContext?.globals?.nextSteps)}></div>
                            </div>
                        </div>
                        <div className="px-4">
                            <div className="px-4">
                                <h3>Upcoming Events</h3>
								 {
                                    globalsContext?.globals?.upcomingEvents.map((upcomingEvents,index)=>{
                                        return (
                                        <div key={index}>
                                         <h4 >{ upcomingEvents?.eventTitle }</h4>
                                       
                                            <div  dangerouslySetInnerHTML={renderHtml(upcomingEvents?.eventType)}></div>
                                       
                                            <div  dangerouslySetInnerHTML={renderDateHtml(upcomingEvents?.eventDate?.date)}></div>    
                                       
                                        <div  dangerouslySetInnerHTML={renderHtml(upcomingEvents?.eventDescription)}></div>
                                        {
                                            upcomingEvents?.registerLink ?
                                                <a href={upcomingEvents?.registerLink}  className="btn-bg-cst">Register</a>:
												<></>
                                        }
                                        </div>
                                    )
                                    })
                                }
                            </div>
                        </div>
                    </div>
        </>
    );
}